import { createStyles, makeStyles } from "@material-ui/core";
import { DataSection, RelodeTheme, Switch } from "@relode/core";
import * as React from "react";
import { useSettingsContext } from "./_infra/settingsProvider";

const useStyles = makeStyles(
    (theme: RelodeTheme) =>
        createStyles({
            root: {
                display: "flex",
                minHeight: "100%",
                flexDirection: "column",
                borderRadius: 1,
                flexGrow: 1,
                flexBasis: "100%",
                padding: theme.spacing(2),
            },
            leftSectionContainer: {
                display: "flex",
                flexDirection: "column",
                minWidth: 225,
            },
            sectionsContainer: {
                display: "flex",
            },
        }),
    { name: "client-settings" }
);

export const ClientSettings = () => {
    const baseId = "clientSettings";
    const classes = useStyles({});
    const { contact, setFieldValue } = useSettingsContext();

    if (!contact) return null;

    const handleToggleClientSummaryEmail = () => {
        setFieldValue(!contact.isAgentActive, "isAgentActive");
    };

    return (
        <div className={classes.root}>
            <div className={classes.sectionsContainer}>
                <div className={classes.leftSectionContainer}>
                    <DataSection label="notifications">
                        <Switch
                            checked={contact.isAgentActive}
                            onSwitchChange={handleToggleClientSummaryEmail}
                            label="Send me a weekly summary of candidates awaiting feedback."
                        ></Switch>
                    </DataSection>
                </div>
            </div>
        </div>
    );
};
